<template>
  <div>
    <div class="valign-wrapper section">
      <span style="padding: 0px 5px 0px 0px">
        <a v-on:click.prevent="toCourseVue()">
          <a class="waves-effect waves-light btn-flat btn-small indigo lighten-5">Курс</a>
        </a>
      </span>

      <span style="padding: 0px 5px 0px 0px">
        <a v-on:click.prevent="toModeProgressVue()">
          <a class="waves-effect waves-light btn-flat btn-small indigo lighten-5">Прогресс</a>
        </a>
      </span>

      <span style="padding: 0px 0px 0px 0px">
        <a v-on:click.prevent="toModeSatzesVue()">
          <a class="waves-effect waves-light btn-flat btn-small indigo lighten-5">Предложения</a>
        </a>
      </span>
    </div>
    
    <br/>
    <a class="indigo-text text-lighten-1">Курс {{course.name}}</a>

    <ModeRegimeHor v-if="idMode0==='Hor-0'" />
    <ModeRegimeSch v-else-if="idMode0==='Sch-0'" />
    <ModeRegimeSp v-else-if="idMode0==='Sp-0'" />
  </div>
</template>

<style scoped>
.section {
  padding-top: 0;
  padding-bottom: 0;
}
</style>



<script>
import ModeRegimeHor from "@/views/ModeRegimeHor";
import ModeRegimeSch from "@/views/ModeRegimeSch";
import ModeRegimeSp from "@/views/ModeRegimeSp";

export default {
  name: "mode",
  components: {
    ModeRegimeHor,
    ModeRegimeSch,
    ModeRegimeSp
  },
  computed: {
    course() {
      return this.$store.getters.course;
    },
    idMode0() {
      return this.$store.getters.idMode0;
    }
  },
  methods: {
    toCourseVue() {
      this.$router.push("/course/course");
    },
    toModeProgressVue() {
      this.$router.push("/course/mode_progress");
    },
    toModeSatzesVue() {
      this.$router.push("/course/mode_satzes");
    }
  },
};
</script>
